import { useLocalStorage } from '@vueuse/core';
export const defaultStdizerOptions = Object.freeze({
    workflow: 'qsar-ready',
});
export const defaultStdizerAppearancePreferences = Object.freeze({
    recordIdField: 'smiles',
    showDetails: false,
});
const LEGACY_VUEX_STORAGE_KEY = 'vuex';
const migrateLegacyStdizerPreferences = () => {
    if (typeof window === 'undefined' || typeof window.localStorage === 'undefined')
        return;
    try {
        const rawLegacyStore = window.localStorage.getItem(LEGACY_VUEX_STORAGE_KEY);
        if (!rawLegacyStore)
            return;
        const parsedLegacyStore = JSON.parse(rawLegacyStore);
        const legacyStdizer = parsedLegacyStore?.stdizer;
        if (!legacyStdizer || !('stateStdizerOptions' in legacyStdizer))
            return;
        if (legacyStdizer.stateStdizerOptions && !window.localStorage.getItem('stdizer.options')) {
            window.localStorage.setItem('stdizer.options', JSON.stringify(legacyStdizer.stateStdizerOptions));
        }
        const nextLegacyStdizer = { ...legacyStdizer };
        delete nextLegacyStdizer.stateStdizerOptions;
        window.localStorage.setItem(LEGACY_VUEX_STORAGE_KEY, JSON.stringify({
            ...parsedLegacyStore,
            stdizer: nextLegacyStdizer,
        }));
    }
    catch {
        // Keep defaults when storage is unavailable or contains invalid data.
    }
};
migrateLegacyStdizerPreferences();
export const stdizerOptionsPreference = useLocalStorage('stdizer.options', { ...defaultStdizerOptions }, { mergeDefaults: true });
export const stdizerAppearancePreference = useLocalStorage('stdizer.appearance', { ...defaultStdizerAppearancePreferences }, { mergeDefaults: true });
